module.exports = __webpack_public_path__ + "img/讨论.7fb3bbd2.svg";